import { Button, Col, Container, Row } from "react-bootstrap";
import "../scss/feature-invoice.style.scss"
import { useTranslation } from "react-i18next";
import { features } from "../constant/feature-invoice.constant";
import { GoArrowRight } from "react-icons/go";
import { useState } from "react";

interface FeatureCardProps {
  title: string;
  description: string;
  icon: string;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, icon }) => {
  const { t } = useTranslation();
  return (
    <Col xs={12} sm={6} md={4} lg={3} className="mb-4 px-0" style={{
      gap: "32px"
    }}>
      <div className="d-flex wi flex-column align-items-start gap-2 h-100 ">
        <div className="feature-card-header">
          <div className="icon-container">
            <img src={icon} alt="" className="feature-card-icon" />
          </div>
          <h3 className="Heading_h5 mb-0">{t(title)}</h3>
        </div>
        <p className="feature-card-description pr-0 pr-sm-5 pr-md-4 pr-lg-5 mt-3 mt-sm-0 mb-0">
          {t(description)}
        </p>
      </div>
    </Col>
  );
};

export const FeatureInvoice = () => {
  const { t } = useTranslation();
  const isMobile = window.innerWidth < 576; // Bootstrap's mobile breakpoint
  const isLaptop = window.innerWidth >= 576 && window.innerWidth < 1440; // Bootstrap's laptop breakpoint
  const [showAll, setShowAll] = useState(false);

  const visibleFeatures = isMobile && !showAll ? features.slice(0, 4) : features;
  return (
    <>

      <Container>
        <h2 className="text-sm-center text-start feature-invoice-title mb-0 ">
          {t("FEATURE_INVOICE_TITLE")}
        </h2>
        <h6 className=" Heading_h6 mt-3 mt-0 text-sm-center text-start mb-0 pb-5 pb-sm-4">
          {t("FEATURE_INVOICE_SUBHEADING_1")} {!isMobile && !isLaptop && <br />}
          {t("FEATURE_INVOICE_SUBHEADING_2")}
        </h6>
        <Row className="padding-80">
          {visibleFeatures.map((feature, idx) => (
            <FeatureCard key={idx} {...feature} />
          ))}

          {isMobile && (
            <Button className="readMore-btn px-3 py-2"
              onClick={() => setShowAll(!showAll)}
            >
              {!showAll ? t('EXPLORE_ALL_FEATURES') : t('HIDE_FEATURES')} <GoArrowRight size={20} className="mx-2" />
            </Button>
          )}
        </Row>
      </Container>
    </>
  );
};
